export default __webpack_public_path__ + "static/media/property_784.1282ed02.png";